<script>
import dayjs from 'dayjs'
import { TenantAppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const sp = new TenantAppServiceProxy()
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    tenant: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const columns = [
      {
        title: '操作',
        key: 'action',
        customRender: (_, record) => {
          return (
            record.id &&
            <span>
            <a v-acl={'page_app_authorization_create'} onClick={() => this.modify(record)}>编辑</a>
          <a-divider type="vertical" />
            <a-popconfirm
          title="确定要删除吗？"
          onConfirm={() => this.delete(record)}
          okText={this.$t('ok')}
          cancelText={this.$t('cancel')}
            >
            <a v-acl={'page_app_authorization_delete'} style={{color: 'red'}}>{this.$t('delete')}</a>
            </a-popconfirm>
            </span>
        )
        }
      },
      {
        title: 'App概要',
        dataIndex: 'appDisplayName'
      },
      {
        title: 'App编号',
        dataIndex: 'appCode'
      },
      {
        title: 'APP序号',
        dataIndex: 'sort'
      },
      {
        title: '授权到期时间',
        dataIndex: 'expireTime',
        customRender: (text,record) => {
          if(record.id) {
            return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      }
    ]
    return {
      columns,
      selectedRowKeys: [],
      appCodeList: []
    }
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          // if(selectedRows.id) {
          console.log(selectedRows)
          this.selectedRowKeys = [...selectedRowKeys]
          this.appCodeList = selectedRows.map(item => item.appCode)
          if (this.appCodeList.length > 0) {
            this.$emit('canDelete', true)
          } else {
            this.$emit('canDelete', false)
          }
          // }
        },
        getCheckboxProps(record) {
          return ({
            style: {
              display: record.id ? 'block' : 'none'
            },
            props: {
              disabled: record.id ? false : true
            }
          })
        }
      }
    }
  },
  methods: {
    modify(record) {
      this.$emit('onEdit', record)
    },
    async delete(record) {
      const body = {
        appCodeList: [record.appCode],
        tenantId: this.tenant.tenantId
      }
      await sp.removeBatchAppCode(body)
      this.$emit('refresh')
    },
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
  },
  render() {
    return (
      <ml-table
        loading={this.loading}
        columns={this.columns}
        dataSource={this.dataSource}
        size="small"
        rowKey="id"
        rowSelection={this.rowSelection}
        canChangeColWidth={true}
        chooseArr={this.selectedRowKeys}
        onCancelChooseArr={this.cancelChooseArr}
      ></ml-table>
    )
  }
}
</script>
